(function (window, $) {

    var typeahead = $('#location-typeahead');
    var locationsList = $('#locations');
    var locationTemplate = $('#location-template').detach().removeClass('hide').removeAttr('id');

    if (typeahead.length) {
        initTypeahead();
    }

    function initTypeahead() {
        var locations = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: 15,
            prefetch: {
                url: typeahead.attr('data-prefetch-url'),
                ttl: 60
            }
        });

        locations.initialize();

        typeahead.typeahead({
            highlight: true
        }, {
            name: 'locations',
            displayKey: 'full_name',
            source: locations.ttAdapter()
        });

        typeahead.on('typeahead:selected', selected);
        typeahead.on('typeahead:autocompleted', autocompleted);

        locationsList.on('click', '.remove-location', removeLocation);
    }

    function selected(event, suggestion, dataset) {
        typeahead.attr('data-selected-id', suggestion.id);
        typeahead.attr('data-selected-name', suggestion.full_name);
        addCurrentLocation();
    }

    function autocompleted(event, suggestion, dataset) {
        typeahead.attr('data-selected-id', suggestion.id);
        typeahead.attr('data-selected-name', suggestion.full_name);
        addCurrentLocation();
    }

    function addCurrentLocation() {
        if (typeahead.typeahead('val') !== typeahead.attr('data-selected-name')) {
            return;
        }

        if (typeahead.attr('data-selected-id') == -1) {
            for (i = 0, len = storstockholm.length; i < len; ++i) {
                var location = locationTemplate.clone();
                var exists = locationsList.find('[name="locations[]"][value="' + storstockholm[i].id + '"]').length > 0;

                if (exists) {
                    continue;
                }

                location.find('input').val(storstockholm[i].id);
                location.find('.location-name').html(storstockholm[i].full_name);
                locationsList.append(location);
            }
        } else if (typeahead.attr('data-selected-id') == -2) {
            for (i = 0, len = helaSverige.length; i < len; ++i) {
                var location = locationTemplate.clone();
                var exists = locationsList.find('[name="locations[]"][value="' + helaSverige[i].id + '"]').length > 0;

                if (exists) {
                    continue;
                }

                location.find('input').val(helaSverige[i].id);
                location.find('.location-name').html(helaSverige[i].full_name);
                locationsList.append(location);
            }
        } else {
            var location = locationTemplate.clone();
            var exists = locationsList.find('[name="locations[]"][value="' + typeahead.attr('data-selected-id') + '"]').length > 0;

            if (exists) {
                return;
            }

            location.find('input').val(typeahead.attr('data-selected-id'));
            location.find('.location-name').html(typeahead.attr('data-selected-name'));
            locationsList.append(location);
        }

        typeahead.typeahead('val', '');
    }

    function removeLocation(event) {
        console.log('hej');
        $(event.target).closest('li').remove();
    }

})(window, jQuery);
